import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import PrivateCASLRoute from "../../../components/PrivateCASLRoute";
import IntlMessages from "../../../util/IntlMessages";
import NotFound from "../../../containers/NotFound";
import {
   getAdminMobilePath,
   getAdminPath,
   lazyWithRetry,
} from "../../../util/router";
import { ACLSubject } from "../../../constants/Enums";
import ErrorBoundary from "../../../components/ErrorBoundary";

//Lazy loading
const MobileDashboard = lazy(() => import("./dashboard"));
const RegistrazioneSopralluoghi = lazyWithRetry(() =>
   import("./registrazione-sopralluoghi")
);
const RegistrazioneSopralluoghiInsert = lazyWithRetry(() =>
   import("./registrazione-sopralluoghi/insert")
);
const RegistrazioneSopralluoghiUpdate = lazyWithRetry(() =>
   import("./registrazione-sopralluoghi/update")
);

const MobileSwitch = ({ user }) => {
   return (
      <ErrorBoundary>
         <Suspense fallback={<IntlMessages id="common.loading" />}>
            <Switch>
               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.CLIENT}
                  exact
                  path={getAdminPath("dashboard")}
                  component={MobileDashboard}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.CLIENT}
                  exact
                  path={getAdminMobilePath("registrazione-sopralluoghi")}
                  component={RegistrazioneSopralluoghi}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.CLIENT}
                  exact
                  path={getAdminMobilePath("registrazione-sopralluoghi/insert")}
                  component={RegistrazioneSopralluoghiInsert}
               />

               <PrivateCASLRoute
                  I="manage"
                  a={ACLSubject.CLIENT}
                  exact
                  path={getAdminMobilePath("registrazione-sopralluoghi/update/:id")}
                  component={RegistrazioneSopralluoghiUpdate}
               />

               <Route path="*" component={NotFound} />
            </Switch>
         </Suspense>
      </ErrorBoundary>
   );
};

export default MobileSwitch;
